export default {
  confirm: 'Potwierdź',
  title: 'Dostępne oferty',
};
